export const useLineChartIntersection = () => {
  const findIntersectionPoint = ({
    data,
    dataKey,
    threshold,
  }: {
    data: any[];
    dataKey: string | number;
    threshold: number;
  }) => {
    for (let i = 0; i < data.length - 1; i++) {
      const current = data[i][dataKey];
      const next = data[i + 1][dataKey];

      if (current <= threshold && next > threshold) {
        // Linear interpolation to find exact intersection
        const ratio = (threshold - current) / (next - current);
        const xPosition = i + ratio;
        const percentage = (xPosition / (data.length - 1)) * 100;

        return {
          index: i,
          ratio,
          percentage,
          x: xPosition,
          y: threshold,
        };
      }
    }

    return null;
  };

  const findLastExceedingPoint = ({
    data,
    dataKey,
    threshold,
  }: {
    data: any[];
    dataKey: string | number;
    threshold: number;
  }) => {
    for (let i = data.length - 1; i >= 0; i--) {
      const value = data[i][dataKey];
      if (value && Number(value) > threshold) {
        return {
          index: i,
          x: i,
          y: Number(value),
        };
      }
    }
    return null;
  };

  const calculateMiddlePosition = (
    intersectionPoint: { x: number; y: number },
    lastExceedingPoint: { x: number; y: number },
    dataLength: number,
  ) => {
    const middleX = (intersectionPoint.x + lastExceedingPoint.x) / 2;
    const middleY = (intersectionPoint.y + lastExceedingPoint.y) / 2;

    // Convert to percentage for positioning
    const percentage = (middleX / (dataLength - 1)) * 100;

    return {
      x: middleX,
      y: middleY,
      percentage,
    };
  };

  return {
    findIntersectionPoint,
    findLastExceedingPoint,
    calculateMiddlePosition,
  };
};
